export default {
  data() {
    return {
      newTitle: document.title,
    };
  },
  methods: {
    setInitialTitle: function (newTitle) {
      document.title = newTitle;
    },
    changeToOldTitle: function () {
      document.title = this.newTitle;
    },
  },
};
